/**
 * Shared Constants
 * Constants used across the application (backend, frontend, website)
 */

/**
 * Supported Languages
 * Language codes supported by the application
 * Used for i18n in both frontend and backend
 */
export const SUPPORTED_LANGUAGES = ['en', 'fr', 'es', 'de', 'it'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/**
 * Notification limits
 */
export const NOTIFICATION_LIMITS = {
  /**
   * Maximum number of notifications to fetch/display
   */
  MAX_NOTIFICATIONS: 20,
} as const;
